const events = {
  creatEvent: {
    stepOne: "معلومات أساسية ومديرين المشروع",
    verificationMethod: "طريقة التحقق من تسجيل الوصول",
    stepTwo: "الأدوار والشفتات",
    stepThree: "المناطق والمتطلبات",
    basicInfo: "معلومات أساسية",
    projectManagers: "مديرين المشروع",
    roles: "الأدوار",
    zones: "المناطق",
    requirements: "المتطلبات",
    comments: "التعليقات",
    agreementFile: "ملف الاتفاقية",
    projectManager: "مدير المشروع",
    role: "الدور",
    zone: "المنطقة",
    addShift: "إضافة فترات العمل",
    requirement: "المتطلبات",
    publishModalConfirmMessage:
      "برجاء الانتباه انه عند نشر الفعاليه سوف يتم عرضها في قائمه الفعاليات القادمه علي تطبيق الموبيل",
    publishPrivateConfirmMsg:
      "يرجى ملاحظة أنه حدث خاص ، يجب دعوة المتقدمين من قبل المسؤولين!",
    confirm: "تأكيد",
    cancel: "إلغاء",
    saveAsDraft: "حفظ كمسودة",
    discardChanges: "تجاهل التغييرات",
    nextStep: "الخطوة التالية : {step}",
    finishAndPublishEvent: "إنهاء ونشر الفعالية",
    finishEvent: "إنهاء",
    publishEventModal: {
      title: "نشر الفعالية؟",
      messageStart: "فعاليتك جاهزة للنشر! بعد النشر ستصبح",
      messageHighlight: "عامة ومرئية",
      messageEnd: "في الفعاليات القادمة على التطبيق",
      publishButton: "نشر الفعالية",
      eventFallbackName: "ملخص الفعالية",
      staffRequested: "{count} موظف مطلوب",
    },
    superAdminCreate: {
      modalTitle: "إنشاء فعالية",
      modalSubtitle: "اختيار شركة العميل",
      modalDescription:
        "اختر الشركة التي سيتم إنشاء الفعالية لها قبل بدء خطوات إنشاء الفعالية.",
      companyFieldLabel: "اختر الشركة المستهدفة",
      companyFieldPlaceholder: "ابحث باسم الشركة أو رقمها",
      registeredCompanies: "{count} شركة مسجلة",
      warningTitle: "سياق الشركة",
      warningMessage:
        "إنشاء فعالية كمدير عام سيربطها بالشركة المحددة. سيتم تطبيق كل قواعد الشركة وأرصدة المحفظة الإلكترونية الخاصة بها.",
      companyRequiredError: "اختر شركة قبل إنشاء الفعالية",
      cancel: "إلغاء",
      next: "التالي: المعلومات الأساسية",
    },
    basicInformation: {
      pageTitle: "الخطوة 1: المعلومات الأساسية",
      pageSubtitle: "أدخل التفاصيل الأساسية لإنشاء ملف الفعالية.",
      eventIdentity: "هوية الفعالية",
      eventTimeline: "الجدول الزمني للفعالية",
      managementClient: "الإدارة والعميل",
      verification: "التحقق",
      managementVerification: "الإدارة والتحقق",
      eventName: "اسم الفعالية",
      eventNamePlaceholder: "أدخل اسم الفعالية",
      eventType: "نوع الفعالية",
      eventTypePlaceholder: "اختر نوع الفعالية",
      locationName: "الموقع",
      locationNamePlaceholder: "أدخل اسم الموقع",
      eventBrief: "نبذة عن الفعالية",
      eventBriefPlaceholder: "اكتب أهداف الفعالية والخلفية...",
      uploadLogo: "رفع الشعار",
      logoUploading: "جاري رفع الصورة",
      recurrence: "التكرار",
      recurrenceAutoMonthlyHint:
        "لأن مدة الفعالية أكثر من 7 أيام، تم تغيير التكرار تلقائياً من يومي إلى شهري.",
      recurrenceDailyBlockedLongEvent:
        "لا يمكن اختيار التكرار اليومي لأن مدة الفعالية أكثر من 7 أيام.",
      daily: "يومي",
      monthly: "شهري",
      singleDayEvent: "فعالية ليوم واحد",
      numberOfDays: "عدد الأيام",
      paidDaysOff: "أيام الإجازة المدفوعة",
      numberOfDaysPlaceholder: "أدخل عدد الأيام",
      paidDaysOffPlaceholder: "أدخل أيام الإجازة المدفوعة",
      entertainment: "ترفيه",
      sports: "رياضة",
      conference: "مؤتمر",
      buildUp: "التجهيز",
      actualEvent: "الفعالية",
      dismantling: "التفكيك",
      start: "البداية",
      end: "النهاية",
      startPlaceholder: "شهر/يوم/سنة --:-- --",
      endPlaceholder: "شهر/يوم/سنة --:-- --",
      checkInMethod: "طريقة التحقق من تسجيل الوصول",
      basicVerification: "التحقق الأساسي",
      supervisorApproval: "موافقة المشرف",
      organizerScanning: "مسح QR المنظم",
      supervisorScanning: "مسح QR المشرف",
      projectManagers: "مديرو مشروع الفعالية",
      addPm: "إضافة مدير",
      assign: "تعيين",
      assignMore: "إضافة المزيد",
      addProjectManagerTitle: "إضافة مدير مشروع",
      addProjectManagerSubtitle: "تعيين موظف للإدارة",
      managerName: "اسم المدير",
      managerNamePlaceholder: "اسم المدير",
      managerSearchPlaceholder: "ابحث بالاسم أو البريد الإلكتروني...",
      managerHelper: "يمكن تعيين الموظفين الموثقين فقط كمديري مشروع.",
      removeProjectManager: "إزالة مدير المشروع",
      projectManagersLoadError:
        "تعذر تحميل الموظفين لتعيين مديري المشروع.",
      projectManagersCompanyRequired:
        "اختر شركة الفعالية قبل تعيين مديري المشروع.",
      responsibility: "المسؤولية",
      responsibilityPlaceholder:
        "مثال: قيادة العمليات، أمن الموقع، علاقات الضيوف...",
      cancel: "إلغاء",
      confirmAddManager: "تأكيد",
      addManager: "إضافة المدير",
      clientName: "اسم العميل",
      clientNamePlaceholder: "اختر أو أدخل اسم العميل",
      location: "الموقع",
      eventLocation: "موقع الفعالية",
      emptyAddress: "اختر الموقع على الخريطة",
      locationBoundaries: "حدود الموقع",
      boundariesPlaceholder: "1000",
      radiusFromCenter: "نصف القطر من نقطة المركز",
      locationAndBoundaries: "الموقع والحدود",
      city: "المدينة",
      cityPlaceholder: "اختر المدينة",
      cityChangedVerifyAddress:
        "لقد غيّرت المدينة — تأكد أن عنوان الموقع لا يزال مطابقًا لها.",
      errors: {
        logo: "شعار الفعالية مطلوب",
        eventName: "اسم الفعالية مطلوب",
        eventType: "نوع الفعالية مطلوب",
        locationName: "اسم الموقع مطلوب",
        city: "المدينة مطلوبة",
        eventBrief: "نبذة الفعالية مطلوبة",
        locationInvalid: "يرجى اختيار موقع صحيح من الخريطة أو إدخال عنوان صحيح.",
        boundaries: "حدود الموقع مطلوبة",
        boundariesPositive: "حدود الموقع يجب أن تكون رقما موجبا",
        actualStart: "بداية الفعالية مطلوبة",
        actualEnd: "نهاية الفعالية مطلوبة",
        endAfterStart: "النهاية يجب أن تكون بعد البداية",
        buildUpPair: "يجب إدخال بداية ونهاية التجهيز معا",
        dismantlingPair: "يجب إدخال بداية ونهاية التفكيك معا",
        checkInMethod: "طريقة التحقق مطلوبة",
        projectManagers: "أضف مدير مشروع واحد على الأقل",
        responsibilityRequired: "المسؤولية مطلوبة",
        clientName: "اسم العميل مطلوب",
        numberOfDays: "عدد الأيام مطلوب",
        numberOfDaysMin: "عدد الأيام يجب أن يكون 1 على الأقل",
        paidDaysOff: "أيام الإجازة المدفوعة مطلوبة",
        paidDaysOffMin: "أيام الإجازة المدفوعة لا يمكن أن تكون سالبة",
        paidDaysOffMaxDays:
          "أيام الإجازة المدفوعة يجب أن تكون أقل من أو تساوي عدد الأيام",
      },
    },
    defineRolesAndShifts: {
      pageTitle: "الأدوار والورديات",
      pageSubtitle: "حدد احتياجات الموظفين والتعويضات لكل دور.",
      addAnotherRole: "إضافة دور آخر",
      rolesNavigation: "تنقل الأدوار",
      emptyTitle: "لا توجد أدوار بعد",
      emptyDescription:
        "أنشئ أول دور لبدء تحديد احتياجات الموظفين، ورديات العمل، وتفاصيل الرواتب.",
      emptyNote: "تحدد الأدوار مسؤوليات وسعة فريق الفعالية",
      addFirstRole: "إضافة أول دور",
      addRole: "إضافة دور",
      roleFallback: "دور",
      roleName: "اسم الدور",
      roleNamePlaceholder: "مثال: مشرف",
      numberOfMales: "عدد الذكور",
      numberOfFemales: "عدد الإناث",
      numberOfMalesPlaceholder: "أدخل عدد الذكور",
      numberOfFemalesPlaceholder: "أدخل عدد الإناث",
      uniformCode: "كود الزي الموحد",
      uniformCodePlaceholder: "مثال: BLU-ORG-01",
      capacity: "السعة",
      shiftCount: "{count} وردية",
      staffCount: "{count} موظف",
      removeRole: "حذف الدور",
      removeRoleMessage: "هل أنت متأكد أنك تريد حذف هذا الدور؟",
      removeRoleHasApplicants:
        "لا يمكن حذف هذا الدور لوجود موظفين معيّنين له.",
      removeRoleWithinLaunchWindowMessage:
        "لا يمكن حذف وظيفة من الفعالية قبل ساعتين من بدء الفعالية أو أثناء استمرارها أو بعد انتهائها",
      roleRemoved: "تم حذف الدور بنجاح",
      roleRemovalPendingSave: "تم تحديد الدور للحذف. احفظ التغييرات لتطبيق الحذف.",
      remove: "إزالة",
      cancel: "إلغاء",
      confirmRemoval: "تأكيد الحذف",
      shiftRemoved: "تم حذف الوردية بنجاح",
      shiftConfiguration: "إعدادات الوردية",
      shiftLabel: "وردية {number}",
      addShift: "إضافة وردية",
      removeShift: "حذف الوردية",
      removeShiftMessage: "هل أنت متأكد أنك تريد إزالة هذه الوردية؟",
      shiftSlot: "نوع الوردية",
      shiftSlotPlaceholder: "اختر نوع الوردية",
      payrollAmount: "إجمالي الراتب",
      payrollPerDay: "الراتب اليومي (تلقائي)",
      shiftTiming: "وقت الوردية",
      startTime: "وقت البداية",
      endTime: "وقت النهاية",
      checkInMargin: "هامش وقت تسجيل الدخول",
      checkOutMargin: "هامش وقت تسجيل الخروج",
      beforeWorkingStarts: "قبل بداية وقت العمل (بالدقائق)",
      afterWorkingStarts: "بعد بداية وقت العمل (بالدقائق)",
      beforeWorkingEnds: "قبل نهاية وقت العمل (بالدقائق)",
      afterWorkingEnds: "بعد نهاية وقت العمل (بالدقائق)",
      paidTraining: "جلسة تدريب مدفوعة",
      paidTrainingDescription: "فعّل لإضافة إعداد إلزامي مدفوع",
      duplicateTrainingTitle: "نسخ التدريب من وردية أخرى؟",
      duplicateTrainingDescription:
        "انسخ كل تفاصيل التدريب بسرعة من وردية موجودة.",
      duplicateTrainingFrom: "النسخ من:",
      trainingName: "اسم التدريب",
      trainingLocation: "موقع التدريب",
      trainingPayroll: "راتب التدريب",
      trainingDescription: "وصف التدريب",
      trainingPaidAmountSar: "المبلغ المدفوع (ر.س.)",
      trainingNumberOfDays: "عدد أيام التدريب",
      trainingTimeline: "توقيت التدريب",
      trainingStart: "وقت بداية التدريب",
      trainingEnd: "وقت نهاية التدريب",
      trainingCheckInMargin: "هامش تسجيل دخول التدريب",
      trainingCheckOutMargin: "هامش تسجيل خروج التدريب",
      beforeTrainingStarts: "قبل بداية التدريب (بالدقائق)",
      afterTrainingStarts: "بعد بداية التدريب (بالدقائق)",
      beforeTrainingEnds: "قبل نهاية التدريب (بالدقائق)",
      afterTrainingEnds: "بعد نهاية التدريب (بالدقائق)",
    },
    zonesAndLogisticalRequirements: {
      pageTitle: "المناطق والمتطلبات اللوجستية",
      pageSubtitle:
        "أكمل المواقع التشغيلية والاحتياجات اللوجستية الخاصة بالفعالية.",
      zoneManagement: "إدارة المناطق",
      addNewZone: "إضافة منطقة جديدة",
      addAnotherZone: "إضافة منطقة أخرى",
      zoneLabel: "منطقة {number}",
      removeZone: "حذف المنطقة",
      removeZoneMessage: "هل أنت متأكد أنك تريد حذف هذه المنطقة؟",
      zoneRemoved: "تم حذف المنطقة بنجاح",
      zoneRemovalPendingSave: "تم تحديد المنطقة للحذف. احفظ التغييرات لتطبيق الحذف.",
      zoneHasOrganizersTooltip: "لا يمكن حذف المنطقة بعد تعيين مشرفين لها",
      zoneName: "اسم المنطقة",
      zoneNamePlaceholder: "مثال: المدخل الرئيسي",
      supervisorName: "اسم المشرف",
      supervisorNamePlaceholder: "أدخل اسم المشرف",
      managerInformation: "معلومات المدير",
      zoneManager: "مدير المنطقة",
      zoneManagerPlaceholder: "اختر مدير المنطقة",
      managerEmail: "البريد الإلكتروني للمدير",
      managerEmailPlaceholder: "manager@proline.sa",
      managerPhone: "هاتف المدير",
      managerPhonePlaceholder: "+966 000 000 000",
      logisticalRequirements: "المتطلبات اللوجستية",
      addItem: "إضافة عنصر",
      requirementName: "اسم المتطلب",
      requirementNamePlaceholder: "أدخل اسم المتطلب",
      quantity: "الكمية",
      explanationNotes: "التوضيح / الملاحظات",
      explanationNotesPlaceholder: "أدخل توضيح المتطلب",
      addNewRequirements: "إضافة متطلبات جديدة",
      removeRequirement: "حذف المتطلب",
      removeRequirementMessage: "هل أنت متأكد أنك تريد حذف هذا المتطلب؟",
      requirementRemoved: "تم حذف المتطلب بنجاح",
      requirementRemovedSaveToApply:
        "تم حذف المتطلب. احفظ الحدث لتطبيق هذا التغيير.",
      zoneRequired: "أضف منطقة واحدة على الأقل",
      requirementRequired: "أضف متطلبا واحدا على الأقل",
      requirementsCatalogEmpty:
        "تعذّر تحميل قائمة المتطلبات. حدّث الصفحة أو أعد المحاولة لاحقاً.",
      zoneMap: "خريطة المناطق",
      zoneMapUploadText: "انقر للرفع أو اسحب وأفلت صورة خريطة تخطيط المناطق",
      zoneMapFormatsHint: "PNG أو JPG أو PDF",
      zoneMapUploading: "جاري رفع الملف",
      zoneMapInvalidType: "يُسمح بصيغ PNG أو JPG أو PDF فقط",
      zoneMapInvalidSize: "الحد الأقصى لحجم الملف 10 ميجابايت",
    },
    labels: {
      uploadLabel: "رفع صورة",
      eventImage: "صورة الفعالية",
      eventName: "اسم الفعالية",
      eventBrief: "نبذة عن الفعالية",
      eventLocation: "موقع الفعالية",
      organizerScanning: "مسح كود المنظم",
      supervisorScanning: "مسح كود المشرف",
      supervisorApproval: "موافقة المشرف",
      basicVerification: "التحقق الأساسي",
      diameter: "حدود الموقع (بالمتر)",
      eventType: "نوع الفعالية",
      publishingMode: "وضع النشر",
      startBuildUpStart: "تاريخ و وقت بدء البناء",
      startBuildUpEnd: "تاريخ و وقت انتهاء البناء",
      eventDayStart: "تاريخ و وقت بدء الفعالية",
      eventDayEnd: "تاريخ و وقت إنتهاء الفعالية",
      dismantlingDayStart: "تاريخ و وقت بدء التفكيك",
      dismantlingDayEnd: "تاريخ و وقت إنتهاء التفكيك",
      pmName: "اسم مدير المشروع",
      responsibility: "المسئولية",
      pmPhone: "رقم الهاتف",
      nameOfRole: "اسم الدور",
      numberOfMales: "عدد الذكور",
      numberOfFemales: "عدد الاناث",
      numberOfShifts: "عدد المناوبات",
      payrollAmount: "مبلغ الراتب",
      workingHours: "عدد ساعات العمل",
      workingShifts: "نوبات العمل",
      shiftType: "نوع النوبة",
      shiftMorning: "صباحي",
      shiftEvening: "مسائي",
      shiftNight: "ليلي",
      shiftFullTime: "دوام كامل",
      uniformCode: "كود الزى الموحد",
      timeToArriveToTheSite: "وقت الوصول الي الموقع",
      zoneName: "اسم المنطقة",
      zoneManager: "مدير المنطقة",
      managerName: "إسم المدير",
      zoneManagerLabel: "اسم مدير المنطقة",
      email: "البريد الالكتروني",
      mobileNumber: "رقم الهاتف المحمول",
      supervisorName: "أسم المشرف",
      supervisorInfo: "معلومات المشرف",
      managerInfo: "معلومات مدير المنطقة",
      zonesMap: "خريطة المناطق",
      nameOfRequirement: "اسم المتطلب",
      quantity: "الكمية",
      explanation: "التوضيح",
      uploadFile: "رفع ملف",
      checkInTimeMargin: "الهامش الزمني لتسجيل الوصول",
      checkOutTimeMargin: "الهامش الزمني لتسجيل المغادرة",
      checkinStart: "قبل بداية وقت العمل (بالدقائق)",
      checkinEnd: "بعد بداية وقت العمل (بالدقائق)",
      checkoutStart: "قبل انتهاء وقت العمل (بالدقائق)",
      checkoutEnd: "بعد انتهاء وقت العمل (بالدقائق)",
      numberOfDays: "عدد الأيام",
      paidDaysOff: "أيام الإجازة المدفوعة",
      shiftTime: "فترات العمل",
      payrollPerDay: "الراتب اليومي",
      paidTraining: "التدريب المدفوع",
      paidTrainingDetails: "تفاصيل التدريب المدفوع",
      trainingName: "اسم التدريب",
      trainingDescription: "وصف التدريب",
      trainingPaidAmount: "المبلغ المدفوع",
      trainingNumberOfDays: "عدد أيام التدريب",
      trainingStartDate: "تاريخ ووقت البداية",
      trainingEndDate: "تاريخ ووقت النهاية",
      trainingCheckInMargin: "هامش وقت تسجيل الدخول",
      trainingCheckOutMargin: "هامش وقت تسجيل الخروج",
      trainingLocation: "موقع التدريب",
      locationBoundaries: "حدود الموقع (بالمتر)",
      trainingLocationBoundariesHelper:
        "نفس حدود الحدث افتراضياً. قابل للتعديل.",
      paidTrainingDescription: "تمكين التدريب المدفوع لهذه الفترة",
      deletePaidTrainingModalMessage:
        "هل أنت متأكد أنك تريد حذف التدريب المدفوع؟",
      duplicateTrainingFromShift: "نسخ التدريب من فترة أخرى",
      selectShiftToDuplicateFrom: "اختر الفترة لنسخ التدريب منها:",
      shiftLabel: "فترة",
      trainingTimeConflictError: "أوقات التدريب تتعارض مع أوقات الفترة",
      trainingTimeCopiedWarning:
        "تم نسخ أوقات التدريب من فترة أخرى. يرجى مراجعتها وتحديثها لتطابق هذه الفترة.",
    },
    placeholders: {
      eventName: "ادخل اسم الفعالية",
      eventBrief: "ادخل نبذة عن الفعالية",
      eventLocation: "اختر موقع الفعالية",
      diameter: "اختر حدود الموقع",
      eventType: "اختر نوع الفعالية",
      startBuildUpStart: "تاريخ و وقت بدء البناء",
      startBuildUpEnd: "تاريخ و وقت انتهاء البناء",
      eventDayStart: "تاريخ و وقت بدء الفعالية",
      eventDayEnd: "تاريخ و وقت إنتهاء الفعالية",
      dismantlingDayStart: "تاريخ و وقت بدء التفكيك",
      dismantlingDayEnd: "تاريخ و وقت إنتهاء التفكيك",
      pmName: "ادخل اسم مدير المشروع",
      responsibility: "ادخل المسئولية",
      nameOfRole: "اختر اسم الدور",
      numberOfMales: "ادخل عدد الذكور",
      numberOfFemales: "ادخل عدد الاناث",
      numberOfShifts: "ادخل عدد المناوبات",
      payrollAmount: "ادخل مبلغ الراتب",
      workingHours: "ادخل عدد ساعات العمل",
      uniformCode: "ادخل كود الزى الموحد",
      timeToArriveToTheSite: "اختر وقت الوصول الى الموقع",
      zoneName: "ادخل اسم المنطقة",
      zoneManager: "ادخل مدير المنطقة",
      email: "ادخل البريد الالكترونى",
      mobileNumber: "ادخل رقم الهاتف المحمول",
      nameOfRequirement: "ادخل اسم المتطلب",
      quantity: "ادخل الكمية",
      explanation: "ادخل التوضيح",
      enterYourComments: "ادخل تعليقاتك",
      selectSupervisor: "أختر مشرف",
      checkinStart: "قبل بداية وقت العمل",
      checkinEnd: "بعد بداية وقت العمل",
      checkoutStart: "قبل انتهاء وقت العمل",
      checkoutEnd: "بعد انتهاء وقت العمل",
      numberOfDays: "عدد الأيام",
      paidDaysOff: "أيام الإجازة المدفوعة",
      payrollPerDay: "الراتب اليومي",
      trainingName: "ادخل اسم التدريب",
      trainingDescription: "ادخل وصف التدريب",
      trainingPaidAmount: "ادخل المبلغ المدفوع",
      trainingNumberOfDays: "ادخل عدد الأيام",
      trainingStartDate: "اختر تاريخ ووقت البداية",
      trainingEndDate: "اختر تاريخ ووقت النهاية",
      trainingCheckInMargin: "ادخل هامش تسجيل الدخول (بالدقائق)",
      trainingCheckOutMargin: "ادخل هامش تسجيل الخروج (بالدقائق)",
      trainingLocation: "ادخل أو اختر الموقع على الخريطة",
      locationBoundaries: "ادخل حدود الموقع",
      trainingLocationBoundariesPlaceholder:
        "نفس حدود الحدث افتراضياً (قابل للتعديل)",
    },
    singleDayEvent: "فعالية ليوم واحد",
    daily: "يومي",
    monthly: "شهري",
    public: "عام",
    private: "خاص",
    add: "إضافة",
    continue: "تابع",
    saveLater: "احفظ وأكمل لاحقا",
    start: "بداية",
    end: "نهاية",
    save: "حفظ",
    saveAndPublish: "حفظ ونشر",
    selectLocationOnMap:
      "برجاء إختيار موقع على الخريطة حتى تتمكن من نشر الفعالية",
    addAtListOnePm:
      "برجاء إضافة مدير مشروع واحد على الأقل حتى تتمكن من نشر الفعالية",
    addAtListOneRole:
      "برجاء إضافة دور واحد على الأقل حتى تتمكن من نشر الفعالية",
    addSlot: "برجاء إضافة الوقت لنشر الفعالية",
    addAtListOneZone:
      "برجاء إضافة منطقة واحدة على الأقل حتى تتمكن من نشر الفعالية",
    addAtListOneRequirement:
      "برجاء إضافة متطلب واحد على الأقل حتى تتمكن من نشر الفعالية",
    addAtListOnePmEditMode: "برجاء إضافة مدير مشروع واحد على الأقل",
    addAtListOneRoleEditMode: "برجاء إضافة دور واحد على الأقل",
    addAtListOneZoneEditMode: "برجاء إضافة منطقة واحدة على الأقل",
    addAtListOneRequirementEditMode: "برجاء إضافة متطلب واحد على الأقل",
    saveContinue: "حفظ ومتابعة",
    noPhoneProvided: "لم يتم توفير رقم هاتف لهذا الموظف",
    autoDeduction: "الخصم التلقائي",
    shifts: {
      morning: "صباحي",
      evening: "مسائي",
      night: "ليلي",
      fullTime: "دوام كامل",
    },
  },
  listEvents: {
    listEventsBreadcrumb: "الفعاليات",
    eventType: "نوع الفاعليه",
    eventId: "رقم الفعالية",
    eventName: "اسم الفعالية",
    owningCompany: "الشركة المالكة",
    companyName: "اسم الشركة",
    city: "المدينة",
    locationVenue: "الموقع والمكان",
    staffingFill: "نسبة التوظيف",
    status: "الحالة",
    filter: "تصفية",
    createEvent: "إنشاء فعالية",
    notAvailable: "-",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    startEndDate: "تاريخ البدء/الانتهاء",
    details: "تفاصيل",
    projectManager: "مدير مشروع",
    searchPlaceHolder: "ابحث عن فعالية",
    searchByNameOrId: "ابحث باسم الفعالية أو رقم المعرف",
    showingEventsRange: "عرض {from}–{to} من أصل {total} فعالية",
    eventsColumn: "الفعاليات",
    eventIdPrefix: "معرف",
    eventIdCaption: "رقم الفعالية:",
    projectManagers: "مديري المشروعات",
    type: "نوع",
    publishMode: "وضع النشر",
    daily: "يومي",
    monthly: "شهري",
    emptyAction: "إنشاء أول فعالية",
    emptyTitle: "لا توجد فعاليات",
    noDataDescription:
      "لا توجد فعاليات قيد التشغيل حاليا. أنشئ فعالية جديدة لبدء إدارة عملياتك.",
    eventTabs: {
      ongoing: "الحاليه",
      upcoming: "القادمه",
      previous: "مكتمل",
      pending: "قيد الانتظار",
      cancelled: "ملغيه",
    },
    eventStatus: {
      ongoing: "الحاليه",
      upcoming: "القادمه",
      past: "مكتمل",
      pending: "قيد الانتظار",
      canceled: "ملغيه",
    },
  },
  viewEvents: {
    eventId: "رقم الفعالية:",
    saudiApplicantsCount: "{count} متقدم سعودي",
    juniorApplicantsSuffix: "أقل من 5 فعاليات",
    location: "الموقع",
    trainingLocation: "موقع التدريب وحدوده",
    eventLocation: "موقع الفعالية",
    city: "المدينة",
    diameter: "حدود الموقع",
    radiusFromCenter: "نصف القطر من نقطة المركز",
    meters: "متر",
    viewEventsBreadcrumb: "تفاصيل الفعالية",
    deleteBtn: "حذف الفعالية",
    cancelBtn: "إلغاء الفعالية",
    editBtn: "تعديل الفعالية",
    basicInfo: "معلومات أساسية",
    notProvided: "غير محدد",
    eventType: "نوع الفعالية",
    publishingMode: "وضع النشر",
    recurrency: "التكرار",
    paidDaysOff: "أيام الإجازة المدفوعة",
    public: "عام",
    private: "خاص",
    projectManagers: "مديرين المشروع",
    client: "العميل",
    roles: "الأدوار",
    zones: "المناطق",
    requirementsAndComments: "المتطلبات والتعليقات",
    add: "إضافة",
    edit: "تعديل",
    noLocation: "لم يتم تحديد الموقع بعد",
    noImage: "لم يتم إختيار صورة بعد",
    noProjectManagers: "لم يتم إضافة مديري المشروع",
    noClient: "لم يتم إضافة عميل",
    noClientAssigned: "لم يتم تعيين عميل",
    noClientAssignedDescription:
      "عيّن عميلاً لهذه الفعالية لإدارة الفوترة والمستندات.",
    clientEmail: "البريد الإلكتروني للعميل",
    clientPhone: "هاتف العميل",
    noRoles: "لم يتم إضافة أدوار",
    noZones: "لم يتم إضافة مناطق",
    emptyRolesTitle: "لم تتم إضافة أدوار بعد",
    emptyRolesDescription:
      "حدّد الأدوار التي تحتاجها فعاليتك لبدء تنظيم الورديات وتوزيع المتقدمين بفعالية.",
    addNewRole: "إضافة دور جديد",
    emptyZonesTitle: "لم يتم إنشاء مناطق بعد",
    emptyZonesDescription:
      "نظّم فعاليتك بإضافة أول منطقة لبدء إدارة الموظفين والعمليات بفعالية في المواقع المختلفة.",
    addNewZone: "إضافة منطقة جديدة",
    workingShifts: "الورديات",
    shiftType: "نوع الوردية",
    totalPayroll: "إجمالي الراتب",
    timeSlot: "الوقت",
    uniformCode: "كود الزي",
    checkInOutMargins: "هامش الحضور والانصراف",
    beforeStart: "قبل البداية",
    afterStart: "بعد البداية",
    beforeEnd: "قبل النهاية",
    afterEnd: "بعد النهاية",
    male: "ذكر",
    female: "أنثى",
    sar: "ريال",
    none: "لا يوجد",
    noRequirements: "لم يتم إضافة متطلبات",
    emptyRequirementsTitle: "لم تتم إضافة متطلبات بعد",
    emptyRequirementsDescription:
      "حدّد المواد والأدوات والاحتياجات اللوجستية المطلوبة لكل منطقة ودور في هذه الفعالية.",
    eventRequirements: "متطلبات الفعالية",
    internalComments: "التعليقات الداخلية",
    requirementName: "اسم المتطلب",
    quantity: "الكمية",
    explanation: "الشرح",
    noComments: "لم يتم إضافة تعليقات",
    emptyCommentsTitle: "لم تتم إضافة تعليقات بعد",
    emptyCommentsDescription:
      "شارك ملاحظاتك الداخلية وتحديثات التنسيق مع فريقك لهذه الفعالية.",
    managerInfo: "معلومات المدير",
    managerEmail: "البريد الإلكتروني",
    managerPhone: "رقم الهاتف المحمول",
    supervisorInfo: "معلومات المشرف",
    supervisorName: "إسم المشرف",
    applicants: "المتقدمين",
    evaluations: "التقييمات",
    timesheet: "ساعات العمل",
    reports: "التقارير",
    clientReports: "تقارير العميل",
    payroll: "الرواتب",
    heatMap: "الخرائط الحرارية",
    heatmapTab: {
      selectZoneToMonitor: "اختر منطقة للمراقبة",
      allZones: "كل المناطق",
      liveTrackingActive: "التتبع المباشر نشط",
      supervisors: "المشرفون",
      organizers: "المنظمون",
      inactive: "غير نشط",
      offline: "غير متصل",
      clusterZoomHint: "قم بالتصغير لتجميع المتقدمين القريبين · قم بالتكبير لعرضهم بشكل فردي",
      clickMarkerHint: "انقر على أي علامة لعرض تفاصيل الموظف",
      staffMembersGrouped: "{count} أعضاء فريق",
      groupedHint: "مجمعون في هذه المنطقة — قم بالتكبير للفصل بينهم",
      zoomIn: "تكبير",
      zoomOut: "تصغير",
      mapLayers: "طبقات الخريطة",
      fullscreen: "ملء الشاشة",
      close: "إغلاق",
    },
    totalNumberOfApplicants: "إجمالي عدد المتقدمين",
    viewApplicantsList: "قائمة المتقدمين",
    fullName: "الاسم الكامل",
    currentStatus: "الحالة الحالية",
    unassigned: "غير معين",
    assigned: "معين",
    notAssignedYet: "لم يتم التعيين بعد",
    staffingSummary: "ملخص التوظيف",
    totalApplicants: "إجمالي المتقدمين",
    totalStaff: "إجمالي الموظفين",
    applicantsTab: {
      supervisor: "مشرف",
      others: "الوظائف الاخرى",
      status: "الحالة",
      gender: "الجنس",
      zone: "المنطقه",
      role: "الوظيفه",
      name: "الاسم",
      email: "البريد الالكتروني",
      note: "ملاحظة",
      shift: "الوردية",
      nationality: "الجنسية",
      city: "المدينة",
      genderOptions: {
        male: "ذكر",
        female: "أنثى",
      },
      placeholders: {
        supervisor: "ابحث باسم المشرف",
        others: "ابحث باستخدام اسم المتقدم او اسم المشرف",
        noData: "لا يوجد متقدمين مقبولين حاليا",
        noSearchResults: "عذرا لا يوجد متقدمين",
      },
      assign: "تحديد",
      remove: "إزالة",
      assigned: "تعيين",
      notAssigned: "غير محدد",
      unassign: "إلغاء تعيين",
      reallocate: "إعادة تعيين",
      unassignApplicant: "إلغاء تعيين موقع مقدم الطلب",
      reallocateApplicant: "إعادة تعيين مقدم الطلب إلى موقع آخر",
      removeApplicant: "إزالة المتقدم من المناطق",
      removeConfirmationMsg:
        "هل أنت متأكد أنك تريد إزالة مقدم الطلب هذا من المنطقة والحدث؟",
      assignApplicant: "تعيين موقع مقدم الطلب",
      unassignConfirmationMsg: "هل أنت متأكد بإلغاء تفعيل منطقه مقدم الطلب ؟",
      inviteMoreApplicants: "ادعو المزيد من المتقدمين",
      inviteApplicants: "ادعو المتقدمين",
      invite: "ادعو",
      searchByApplicant: "ابحث باستخدام اسم المتقدم",
      hint: "لتغيير الوظيفه قبل دعوة المتقدمين برجاء التغيير من قائمه الوظائف",
      selectFile: "حدد الحقول لتصدير CSV",
      export: "تصدير",
      exportAll: "تصدير الكل",
      clearSelection: "مسح التحديد",
      timeConflict: "تعارض زمني",
      selectAll: "تحديد الكل",
      trainingDays: "أيام التدريب",
      trainingDailyAmount: "راتب التدريب اليومي",
      trainingTotalAmount: "إجمالي راتب التدريب",
      totalShiftAmount: "إجمالي مبلغ الفترة",
      joiningRequestsStatusTabs: {
        pending: "قيد الانتظار",
        joined: "منضم",
        rejected: "مرفوض",
        removed: "محذوف",
      },
      joiningRequests: {
        searchPlaceholder: "البحث بالاسم أو الرقم التعريفي",
        emptyStates: {
          pending: {
            title: "لا توجد طلبات قيد الانتظار",
            description:
              "تمت مراجعة جميع طلبات المتقدمين. ستظهر الطلبات الجديدة هنا عند ورودها.",
          },
          joined: {
            title: "لا يوجد متقدمون منضمون",
            description:
              "لا يوجد متقدمون منضمون بعد. وافق على الطلبات قيد الانتظار لإضافة متقدمين هنا.",
          },
          rejected: {
            title: "لا يوجد متقدمون مرفوضون",
            description:
              "لا يوجد متقدمون مرفوضون في هذه الفعالية حتى الآن. ستظهر الطلبات المرفوضة هنا.",
          },
          removed: {
            title: "لا يوجد متقدمون محذوفون",
            description:
              "لا يوجد متقدمون محذوفون في هذه الفعالية حتى الآن. سيظهر المتقدمون المحذوفون هنا.",
          },
        },
        filteredEmptyState: {
          title: "لا توجد نتائج",
          description:
            "لا يوجد متقدمون يطابقون معايير البحث أو التصفية. حاول تعديل البحث أو الفلاتر.",
        },
        rangeTemplate: "عرض {from}–{to} من أصل {total} متقدمين",
        rowsPerPageLabel: "عدد الصفوف",
        selectedCount: "تم اختيار {count}",
        workingHoursFilter: {
          label: "ساعات العمل",
          options: {
            less_than_250: "أقل من 250",
            "250_to_450": "250 إلى 450",
            "450_to_850": "450 إلى 850",
            more_than_850: "أكثر من 850",
          },
        },
        requestDateFilter: {
          from: "من تاريخ",
          to: "إلى تاريخ",
        },
        bulkActions: {
          approve: "موافقة",
          reject: "رفض",
          accept: "قبول",
          cancel: "إلغاء",
          unassign: "إلغاء التعيين",
          reallocate: "إعادة التعيين",
          allocate: "تعيين",
          export: "تصدير",
          editRole: "تعديل الدور",
          remove: "إزالة",
          reactivate: "إعادة التفعيل",
          editReason: "تعديل السبب",
          addEditTag: "إضافة/تعديل وسم",
          deleteTag: "حذف الوسم",
        },
        tagModal: {
          titleAdd: "إضافة وسم",
          titleEdit: "تعديل الوسم",
          hint: "اختر وسمًا",
          selectTag: "اختر وسمًا",
          save: "حفظ الوسم",
          cancel: "إلغاء",
          assignSkipInfo:
            "<b>{count} من {total} من المتقدمين</b> لديهم وسوم بالفعل وسيتم تخطّيهم. سيُطبّق الوسم فقط على <b>المتقدمين المتبقّين البالغ عددهم {remaining}</b>.",
          assignSuccess: "تم حفظ الوسم لعدد {count} من المتقدمين",
          allAlreadyTagged:
            "جميع المتقدمين المحددين البالغ عددهم {count} لديهم وسوم معيّنة بالفعل.",
        },
        deleteTagModal: {
          title: "حذف الوسم",
          deleteSingle: "أنت على وشك إزالة هذا الوسم.",
          deleteMultiple: "أنت على وشك إزالة الوسوم من عدة متقدمين.",
          deleteQuestion: "هل أنت متأكد أنك تريد المتابعة؟",
          cancel: "إلغاء",
          deleteConfirm: "حذف",
          noneToDelete:
            "لا يوجد لدى أي من المتقدمين المحددين البالغ عددهم {count} وسوم معيّنة. لا يوجد ما يمكن حذفه.",
          deleteUntaggedSkip:
            "{count} من المتقدمين ليس لديهم وسوم وسيتم تخطّيهم. ستتم إزالة الوسوم فقط من المتقدمين المتبقّين البالغ عددهم {remaining}.",
          deleteOtherOwnerSkip:
            "{count} من المتقدمين سيتم تخطّيهم. ستتم إزالة الوسوم فقط من المتقدمين المتبقّين البالغ عددهم {remaining}.",
          deleteSuccess: "تم حذف الوسم لعدد {count} من المتقدمين",
        },
        approveModal: {
          title: "الموافقة على الطلب",
          editRoleTitle: "تعديل الدور",
          requestedRole: "الدور المطلوب",
          singleMessage:
            "يتطلب هذا الإجراء انتباهك. يرجى مراجعة التفاصيل قبل المتابعة.",
          bulkMessage: "أنت على وشك الموافقة على {count} متقدمين محددين.",
          editRoleBulkMessage:
            "أنت على وشك تعديل الدور لـ {count} من المتقدمين المحددين.",
          singleHint:
            "يتطلب هذا الإجراء انتباهك. يرجى مراجعة التفاصيل قبل المتابعة.",
          bulkHint: "سيتم تطبيق هذا الإجراء على كل المتقدمين المحددين.",
          editRoleHint: "اختر الدور والوردية الجديدة للمتقدمين المحددين.",
          currentRole: "الموافقة بنفس الدور",
          changeRole: "تغيير الدور قبل الموافقة",
          newRole: "الدور الجديد",
          newShift: "الوردية الجديدة",
          selectRole: "اختر الدور",
          selectShift: "اختر الوردية",
          shiftTemplate: "--{shift}--",
          bulkRoleChangeTo: "الدور: {role} ",
          bulkShiftChangeTo: "الوردية: {shift} ",
          changeSummaryDescription:
            "سيتم إشعار المتقدمين بتغييرات الدور والوردية.",
          cancel: "إلغاء",
          approve: "موافقة",
          saveRole: "حفظ",
        },
        changeRoleModal: {
          title: "تغيير الدور",
          singleMessage: "تحديث الدور والوردية لهذا المتقدم",
          bulkMessage: "أنت على وشك تغيير دور ووردية {count} متقدمين إلى دور ووردية واحدة",
          mixedMessage: "يتضمن اختيارك متقدمين عاديين ومشرفين",
          selectedTemplate: "تم اختيار {count} متقدمين",
          mixOfRolesAndShifts: "مزيج من الأدوار والورديات",
          newRole: "الدور الجديد",
          newShift: "الوردية الجديدة",
          selectRole: "اختر الدور",
          selectShift: "اختر الوردية",
          overrideTitle: "سيتم استبدال بيانات جميع المتقدمين المحددين",
          overrideSupervisorTitle:
            "سيؤدي هذا الإجراء إلى استبدال بيانات جميع المتقدمين المحددين، بما في ذلك المشرف.",
          overrideDescription:
            "سيحل الدور والوردية الجديدان محل البيانات الحالية لكل المتقدمين وعددهم {count}.",
          demotionTitle: "سيؤدي تغيير هذا الدور إلى خفض رتبة هذا المشرف",
          singleDemotionDescription:
            "{name} مشرف معين في {zone}. سيؤدي تغيير دوره إلى:",
          singleUnassignedDemotionDescription:
            "{name} مشرف. سيؤدي تغيير دوره إلى:",
          bulkDemotionWarning:
            "سيؤدي تغيير هذا الدور إلى خفض رتبة المشرف/المشرفين المحددين. ستحتاج إلى تعيين مشرف/مشرفين جدد لمناطقهم.",
          removeSupervisorStatus: "إزالة حالة المشرف",
          unassignZones: "إلغاء تعيينهم من {zone}",
          zonesNeedSupervisor: "{zone} ستبقى بدون مشرف حتى إعادة التعيين",
          notifyApplicants: "إشعار المتقدمين الذين تغيرت وظائفهم",
          cancel: "إلغاء",
          confirm: "تأكيد",
        },
        allocateModal: {
          title: "تعيين",
          confirmTitle: "تأكيد التعيين",
          singleMessage: "أنت على وشك تعيين هذا المتقدم إلى منطقة",
          bulkMessage: "أنت على وشك تعيين {count} متقدمين إلى منطقة واحدة",
          mixedSelectionMessage:
            "يتضمن اختيارك متقدمين عاديين ومشرفين. سيتم تعيين المتقدمين العاديين فقط أدناه.",
          selectedTemplate: "{count} متقدمين محددين",
          selectedRegularTemplate: "{count} متقدمين عاديين محددين",
          selectedRegularSingularTemplate: "{count} متقدم عادي محدد",
          mixedAssignment: "مزيج من الموظفين المعينين وغير المعينين",
          allAllocatedTemplate: "كل {count} المتقدمين سيتم تعيينهم هنا",
          breakdownTemplate: "{unassigned} غير معين / {assigned} إعادة تعيين",
          assignedStatus: "معين حاليا",
          unassignedStatus: "غير معين حاليا",
          zone: "المنطقة",
          selectZone: "اختر المنطقة",
          supervisor: "مشرف",
          supervisorsNoAction: "{count} مشرفين: لا يوجد إجراء",
          supervisorsHintPrefix: "استخدم تبويب ",
          supervisorsHintEmphasis: "المناطق",
          supervisorsHintSuffix: " لتعيينهم",
          zonesTab: "تبويب المناطق",
          back: "رجوع",
          cancel: "إلغاء",
          approve: "موافقة",
        },
        unassignModal: {
          confirmTitle: "تأكيد إلغاء التعيين",
          supervisorTitle: "تم اختيار مشرفين",
          singleQuestion:
            '"هل أنت متأكد أنك تريد إلغاء تعيين هذا المتقدم من منطقته؟"',
          bulkQuestion:
            '"هل أنت متأكد أنك تريد إلغاء تعيين {count} متقدمين من مناطقهم؟"',
          supervisorBody:
            "اختيارك لـ {count} متقدمين يتضمن {supervisors} مشرفين. إلغاء تعيينهم سيترك المناطق الخاصة بهم بدون قيادة. هل أنت متأكد أنك تريد المتابعة وإلغاء تعيين كل المتقدمين المحددين؟",
          clearZoneHint:
            "سيتم مسح المنطقة وتغيير حالة التعيين إلى غير معين.",
          bulkSummary:
            "({assigned}) سيتم إلغاء تعيينهم - ({unassigned}) غير معينين بالفعل وسيتم تخطيهم",
          zoneWillBeCleared: "سيتم مسح المنطقة",
          statusChange: "حالة التعيين: معين ← غير معين",
          nothingTitle: "لا يوجد ما يتم إلغاء تعيينه",
          nothingBody: "كل المتقدمين المحددين غير معينين بالفعل.",
          nothingDetails:
            "كل {count} المتقدمين المحددين لا يملكون منطقة معينة. لا يوجد ما يتم إلغاء تعيينه ولن يتم عمل أي تغييرات.",
          assignedStatus: "معين حاليا",
          supervisor: "مشرف",
          cancel: "إلغاء",
          unassign: "إلغاء التعيين",
          ok: "حسنا، فهمت",
        },
        removeModal: {
          title: "تأكيد الإزالة",
          singleQuestion:
            "هل أنت متأكد أنك تريد إزالة هذا المتقدم من هذه الفعالية؟",
          bulkQuestion:
            "هل أنت متأكد أنك تريد إزالة {count} متقدمين من هذه الفعالية؟",
          singleSupervisorTitle: "هذا المتقدم مشرف",
          singleSupervisorDescription:
            "ستؤدي إزالته إلى ترك {zone} بدون مشرف.",
          singleUnassignedSupervisorDescription:
            "ستؤدي إزالته إلى حذف هذا المشرف من الفعالية.",
          bulkSupervisorTitle: "تم تضمين {count} مشرفين",
          bulkSupervisorDescription: "ستصبح مناطقهم بدون مشرفين",
          reasonLabel: "سبب الإزالة",
          reasonRequired: "سبب الإزالة مطلوب",
          placeholder: "اكتب سبب الإزالة",
          cancel: "إلغاء",
          remove: "إزالة",
        },
        reactivateModal: {
          singleTitle: "إعادة تفعيل المتقدم؟",
          bulkTitle: "إعادة تفعيل المتقدمين؟",
          singleMessageBefore: "هل أنت متأكد أنك تريد إعادة تفعيل ",
          singleMessageAfter: "؟ سيتم نقله إلى حالته السابقة.",
          bulkMessage:
            "هل أنت متأكد أنك تريد إعادة تفعيل {count} من المتقدمين المحددين في هذه الفعالية؟ سيتم نقلهم إلى حالتهم السابقة.",
          cancel: "إلغاء",
          confirm: "إعادة التفعيل",
          successTitle: "تمت إعادة تفعيل المتقدم",
          successBody: "تم نقل المتقدم إلى قائمة المتقدمين المنضمين.",
          bulkSuccessTitle: "تمت إعادة تفعيل المتقدمين",
          bulkSuccessBody: "تم نقل المتقدمين المحددين إلى قائمة المتقدمين المنضمين.",
        },
        editRemovalReasonModal: {
          title: "تعديل سبب الإزالة",
          singleMessage: "حدّث سبب الإزالة لهذا المتقدم.",
          bulkMessage: "حدّث سبب الإزالة لـ {count} من المتقدمين المحددين.",
          requestedRole: "الدور المطلوب",
          reasonLabel: "سبب الإزالة",
          reasonRequired: "سبب الإزالة مطلوب",
          placeholder: "اكتب سبب الإزالة",
          cancel: "إلغاء",
          save: "حفظ",
        },
        rejectModal: {
          title: "تأكيد الرفض",
          bulkMessage: "أنت على وشك رفض {count} متقدمين محددين.",
          hint: "يتطلب هذا الإجراء انتباهك. يرجى مراجعة التفاصيل قبل المتابعة.",
          reasonLabel: "سبب الرفض",
          placeholder: "اكتب السبب هنا...",
          cancel: "إلغاء",
          reject: "رفض",
        },
        allocationStatusFilter: {
          placeholder: "حالة التعيين",
          options: {
            assigned: "معين",
            notAssigned: "غير معين",
          },
        },
        applicantTypeFilter: {
          placeholder: "نوع المتقدم",
          options: {
            loyal: "المتقدمون المخلصون",
            other: "المتقدمون الآخرون",
          },
          emptyState: {
            loyal: {
              title: "لا يوجد متقدمون مخلصون",
              description:
                "لا يوجد متقدمون يطابقون هذا الفلتر في المرحلة الحالية.",
            },
            other: {
              title: "لا يوجد متقدمون آخرون",
              description:
                "لا يوجد متقدمون يطابقون هذا الفلتر في المرحلة الحالية.",
            },
          },
        },
      },
      joiningRequestsTable: {
        id: "المعرّف",
        staffApplicant: "الموظف / المتقدم",
        nationality: "الجنسية",
        zone: "المنطقة",
        role: "الدور",
        requestedRole: "الدور المطلوب",
        requestDate: "تاريخ الطلب",
        removedDate: "تاريخ الإزالة",
        removeReason: "سبب الإزالة",
        shift: "الوردية",
        checkIn: "تسجيل الدخول",
        checkedIn: "سجل الدخول",
        nonCheckedIn: "لم يسجل الدخول",
        workingHours: "ساعات العمل",
        rating: "التقييم",
        tags: "الوسوم",
        addTag: "إضافة وسم",
        workingHoursUnit: "ساعة",
      },
      joinedApplicantsSummary: {
        checkedIn: "سجل الدخول",
        notCheckedIn: "لم يسجل الدخول",
        exportAll: "تصدير الكل",
        loyalApplicants: "المتقدمون الموالون",
        otherApplicants: "متقدمون آخرون",
      },
    },
    payrollTab: {
      autoDeduction: "الخصم التلقائي",
      lateCheckIn: "تأخر تسجيل الدخول",
      autoCheckout: "تسجيل الخروج التلقائي",
      payFullShift: {
        label: "دفع الوردية المجدولة كاملة",
        tooltip:
          "يتحكم في احتساب وقت تسجيل الخروج الفعلي ضمن حساب الرواتب. عند التفعيل، تُحتسب ساعات العمل على أساس الوردية المجدولة كاملة. ينطبق على الفعاليات اليومية فقط.",
      },
      summary: {
        paidPayment: "دفعة مدفوعة",
        pendingPayment: "دفعة معلقة",
      },
      searchPlaceholder: "البحث باسم المتقدم أو الرقم...",
      giveAllRewards: "منح مكافآت لجميع المستخدمين",
      generateAllPayroll: "عرض رواتب جميع المتقدمين",
      selectedCount: "تم تحديد {count}",
      rowsPerPageLabel: "عدد الصفوف",
      rangeTemplate: "عرض {from}-{to} من {total} متقدم",
      addProof: "إضافة إثبات",
      columns: {
        id: "الرقم",
        staff: "الموظف/المتقدم",
        role: "الدور الحالي",
        nationality: "الجنسية",
        finalPayroll: "الراتب النهائي",
        paymentStatus: "حالة الدفع",
        paymentProof: "إثبات الدفع",
      },
      paymentStatuses: {
        pending: "معلق",
        paid: "مدفوع",
      },
      filters: {
        gender: "الجنس",
        role: "الدور",
        nationality: "الجنسية",
        removedStatus: "حالة المتقدم",
        rewardType: "التعديل",
        paymentStatus: "حالة الدفع",
        assigned: "معين",
        removed: "محذوف",
        reward: "به مكافأة",
        dedication: "به خصم",
      },
      bulkActions: {
        attachAndMarkPaid: "إرفاق وتحديد كمدفوع",
        generatePayroll: "عرض تقرير الراتب",
        giveReward: "منح مكافأة",
        manualDeduction: "خصم يدوي",
      },
      attachMarkPaid: {
        title: "رفع إثبات المعاملة",
        subtitleSingle: "رفع إثبات المعاملة لـ {name}",
        subtitleBulk: "رفع إثبات المعاملة لـ {count} متقدمين",
        markAsPaid: "تحديد كمدفوع",
        clickToUpload: "انقر للرفع",
        dragHint: "أو اسحب وأفلت",
        hint: "PNG أو JPG أو PDF — الحد الأقصى 10 ميجابايت (ملف واحد).",
        fileRequired: "إثبات المعاملة مطلوب",
        invalidType:
          "نوع ملف غير صالح. يُقبل فقط ملفات PNG و JPG و PDF.",
        invalidSize: "حجم الملف يتجاوز 10 ميجابايت. يرجى رفع ملف أصغر.",
        uploadFailed: "فشل الرفع. حاول مرة أخرى",
      },
      viewProof: {
        title: "إثبات المعاملة",
        readyToUpload: "جاهز للرفع",
        readyMeta: "جاهز للرفع • {size}",
      },
      manualAdjustment: {
        amountLabel: "المبلغ ({currency})",
        chooseReason: "اختر السبب",
        validation: {
          amountRequired: "يجب أن يكون المبلغ أكبر من 0",
          reasonRequired: "السبب مطلوب",
          reasonsLoadFailed: "فشل تحميل الأسباب. يرجى المحاولة مرة أخرى.",
        },
        reward: {
          title: "إضافة مكافأة",
          reasonLabel: "سبب المكافأة",
          apply: "تطبيق المكافأة",
          subtitleSingle: "تطبيق مكافأة لـ {name}",
          subtitleBulk: "سيتم تطبيق هذه المكافأة على {count} متقدم",
          subtitleAll: "سيتم تطبيق هذه المكافأة على جميع المتقدمين",
          successSingle: "تم تطبيق المكافأة بنجاح",
          successBulk: "تم تطبيق المكافأة على {count} متقدم بنجاح",
          successPartial: "تم تطبيق المكافأة على بعض المتقدمين، ولم يتم تطبيقها على البعض الآخر.",
        },
        deduction: {
          title: "خصم يدوي",
          reasonLabel: "سبب الخصم",
          apply: "تطبيق الخصم",
          subtitleSingle: "تطبيق خصم على: {name}",
          subtitleBulk: "سيتم تطبيق هذا الخصم على {count} متقدم",
          successSingle: "تم تطبيق الخصم بنجاح",
          successBulk: "تم تطبيق الخصم على {count} متقدم بنجاح",
          successPartial: "تم تطبيق الخصم على بعض المتقدمين، ولم يتم تطبيقه على البعض الآخر.",
        },
        rowActions: {
          generatePayroll: "إنشاء الراتب",
          giveReward: "منح مكافأة",
          manualDeduction: "خصم يدوي",
          ariaLabel: "إجراءات الرواتب",
        },
      },
      generatePayroll: {
        singleTitle: "راتب المتقدم",
        singleSubtitle: "تفصيل كامل للأجر خلال فترة عمل هذا المتقدم.",
        bulkTitle: "تقرير الرواتب",
        bulkSubtitle: "مراجعة وتصدير الرواتب لـ {count} متقدم.",
        applicantDetails: "تفاصيل المتقدم",
        staffName: "اسم الموظف",
        reportPeriod: "فترة التقرير",
        startDate: "تاريخ البداية",
        endDate: "تاريخ النهاية",
        endDateBeforeStartDate: "تاريخ النهاية لا يمكن أن يكون قبل تاريخ البداية",
        stcNo: "رقم STC",
        loading: "جاري تحميل تقرير الرواتب",
        summary: {
          baseEarnings: "الأرباح الأساسية",
          deductions: "الخصومات",
          rewards: "المكافآت",
          training: "التدريب",
          finalNetPay: "صافي الأجر النهائي",
          totalDeductions: "إجمالي الخصومات",
          totalRewards: "إجمالي المكافآت",
          totalNetPay: "إجمالي صافي الأجر",
          currency: "ريال",
        },
        sections: {
          baseEarnings: "الأرباح الأساسية",
          training: "التدريب",
          deductions: "الخصومات",
          rewards: "المكافآت",
          autoDeductionReason: "خصم تلقائي",
          baseEarningsMeta: "{roles} أدوار - {days} أيام إجمالاً",
          trainingMeta: "{roles} أدوار - {days} أيام إجمالاً",
          deductionsMeta: "{count} إدخالات",
          rewardsMeta: "{count} إدخالات",
          roleRank: "الدور {rank}",
          days: "{count} أيام",
          ratePerDay: "{amount}/يوم",
          add: "إضافة إدخال",
          typeAuto: "تلقائي",
          typeManual: "يدوي",
          systemTag: "النظام",
          revertEntry: "تراجع عن الإدخال",
          addDeduction: "إضافة خصم",
          addReward: "إضافة مكافأة",
          baseEarningsEmptyTitle: "لا توجد ورديات عمل",
          baseEarningsEmptyDescription:
            "لم يتم تسجيل أي حضور خلال هذه الفترة.",
          trainingEmptyTitle: "لا توجد ورديات تدريب",
          trainingEmptyDescription:
            "لم يتم تسجيل أي تدريب خلال هذه الفترة.",
          deductionsEmptyDescription:
            "لم يتم تطبيق أي خصم خلال هذه الفترة.",
          rewardsEmptyDescription: "لم يتم تطبيق أي مكافأة خلال هذه الفترة.",
        },
        columns: {
          id: "الرقم",
          staff: "الموظف/المتقدم",
          days: "الأيام",
          shiftPay: "أجر الوردية",
          autoDeduction: "خصم تلقائي",
          manualDeduction: "خصم يدوي",
          rewards: "المكافآت",
          trainingDays: "أيام التدريب",
          trainingPay: "أجر التدريب",
          totalAmount: "المبلغ الإجمالي",
          stcNo: "رقم STC",
          roleCount: {
            zero: "{count} أدوار",
            one: "{count} دور",
            two: "{count} دورين",
            few: "{count} أدوار",
            other: "{count} دور",
          },
        },
        shifts: {
          fulltime: "دوام كامل",
          morning: "صباحي",
          afternoon: "مسائي",
          night: "ليلي",
        },
        rolesLegend: "الأدوار",
        trainingsLegend: "التدريبات",
        ratePerDayLegend: "{role} {amount}/يوم",
        actions: {
          back: "رجوع",
          exportReport: "تصدير التقرير",
          revertDeduction: "تراجع عن الخصم",
          revertReward: "تراجع عن المكافأة",
        },
        footer: {
          single: "مراجعة راتب هذا المتقدم.",
          bulk: "إنشاء رواتب لـ {count} متقدم",
        },
        toast: {
          exportReport: "تم تصدير تقرير الرواتب.",
          revertDeduction: "تم التراجع عن الخصومات اليدوية.",
          revertReward: "تم التراجع عن المكافآت.",
          revertDeductionEntry: "تم التراجع عن الخصم بنجاح.",
          revertRewardEntry: "تم التراجع عن المكافأة بنجاح.",
          addDeduction: "تمت إضافة الخصم بنجاح.",
          addReward: "تمت إضافة المكافأة بنجاح.",
        },
        revertConfirm: {
          deductionAllTitle: "التراجع عن جميع الخصومات؟",
          deductionAllDescription:
            "سيؤدي هذا إلى إزالة جميع إدخالات الخصم المضافة يدويًا لهذا المتقدم. لا يمكن التراجع عن هذا الإجراء.",
          deductionAllWarning:
            "ستبقى الخصومات التلقائية كما هي.",
          deductionAllWarningDescription: "هذا الإجراء يتراجع عن الخصومات اليدوية فقط.",
          deductionAllConfirm: "نعم، تراجع عن الخصم",
          deductionSingleTitle: "التراجع عن هذا الخصم؟",
          deductionSingleDescription:
            "سيؤدي هذا إلى إزالة إدخال الخصم هذا لهذا المتقدم.",
          deductionSingleConfirm: "نعم، تراجع عن الخصم",
          rewardAllTitle: "التراجع عن جميع المكافآت؟",
          rewardAllDescription:
            "سيؤدي هذا إلى إزالة جميع إدخالات المكافآت لهذا المتقدم وتعيين إجمالي المكافآت إلى 0. لا يمكن التراجع عن هذا الإجراء.",
          rewardAllConfirm: "نعم، تراجع عن المكافآت",
          rewardSingleTitle: "التراجع عن هذه المكافأة؟",
          rewardSingleDescription:
            "سيؤدي هذا إلى إزالة إدخال المكافأة هذا لهذا المتقدم.",
          rewardSingleConfirm: "نعم، تراجع عن المكافأة",
        },
      },
      emptyStates: {
        event: {
          title: "لا توجد سجلات رواتب بعد",
          description:
            "ستظهر بيانات الرواتب هنا بمجرد إكمال الموظفين لوردياتهم في هذا الحدث.",
        },
        filtered: {
          title: "لا توجد نتائج",
          description:
            "لا توجد سجلات رواتب تطابق البحث أو عوامل التصفية. حاول تعديل البحث أو الفلاتر.",
        },
      },
      toast: {
        giveAllRewards: "تم تطبيق المكافأة على جميع المتقدمين المعتمدين.",
        generateAllPayroll: "بدأ إنشاء الرواتب لجميع المستخدمين.",
        attachAndMarkPaid: "تم تحديد المتقدمين المحددين كمدفوع.",
        generatePayroll: "تم إنشاء الرواتب للمتقدمين المحددين.",
        giveReward: "تم تطبيق المكافأة على المتقدمين المحددين.",
        manualDeduction: "تم تطبيق الخصم اليدوي على المتقدمين المحددين.",
        addProof: "تم رفع إثبات الدفع.",
        autoDeduction:
          "تم تحديث إعدادات الخصم التلقائي. لن تتأثر الخصومات الحالية — يسري التغيير على الإجراءات المستقبلية فقط.",
        payFullShift: "تم تحديث إعداد احتساب الرواتب.",
      },
    },
    timesheetTab: {
      searchPlaceholder: "البحث بالاسم أو الرقم",
      exportAll: "تصدير الكل",
      exportModal: {
        title: "تصدير التقرير إلى ملف CSV",
        description:
          "اختر الحقول التي تريد تضمينها في ملف CSV. يجب اختيار حقل واحد على الأقل.",
        selectAll: "تحديد كل الحقول",
        confirmExport: "تأكيد التصدير",
        successTitle: "تم تصدير التقرير",
        successMessage: "ملف CSV جاهز. سيبدأ التنزيل تلقائيًا.",
        errorTitle: "فشل التصدير",
        errorMessage:
          "تعذر إنشاء التقرير. يرجى المحاولة مرة أخرى أو التواصل مع الدعم إذا استمرت المشكلة.",
      },
      applicantName: "اسم المتقدم",
      workingDays: "أيام العمل",
      workingHours: "ساعات العمل",
      trainingDays: "أيام التدريب",
      status: "الحالة",
      applicantRole: "دور المتقدم",
      applicantStatus: "حالة المتقدم",
      startDate: "تاريخ البداية",
      endDate: "تاريخ النهاية",
      shift: "الوردية",
      workingHoursPerDay: "ساعات العمل/اليوم",
      shiftsTab: "الورديات",
      trainingsTab: "التدريبات",
      statuses: {
        approved: "معتمد",
        removed: "محذوف",
        cancelled: "ملغي",
      },
      emptyStates: {
        event: {
          title: "لا توجد بيانات سجل دوام",
          description:
            "سيظهر سجل الدوام ومواعيد العمل للمتقدمين هنا بمجرد بدء الورديات",
        },
        shifts: {
          title: "لا توجد ورديات مسجلة بعد",
          description:
            "لم يتم تسجيل أي ورديات لهذا المتقدم. ستظهر المواعيد المضافة هنا.",
        },
        trainings: {
          title: "لا توجد جلسات تدريب مسجلة بعد",
          description:
            "لم يتم تسجيل أي جلسات تدريب لهذا المتقدم. ستظهر الجلسات المضافة هنا.",
        },
        filtered: {
          title: "لا توجد نتائج",
          description:
            "لا توجد سجلات ساعات عمل تطابق معايير البحث أو التصفية. حاول تعديل البحث أو الفلاتر.",
        },
      },
      rangeTemplate: "عرض {from}-{to} من {total} متقدم",
      rowsPerPageLabel: "عدد الصفوف",
      addSlotModal: {
        shiftTitle: "إضافة وردية",
        trainingTitle: "إضافة جلسة تدريب",
        editShiftTitle: "تعديل وردية",
        editTrainingTitle: "تعديل جلسة تدريب",
        subtitle: "إضافة توقيت لـ {name}",
        editSubtitle: "تعديل توقيت لـ {name}",
        checkInDate: "تاريخ تسجيل الدخول",
        checkInTime: "وقت تسجيل الدخول",
        checkOutDate: "تاريخ تسجيل الخروج",
        checkOutTime: "وقت تسجيل الخروج",
        saveChanges: "حفظ التغييرات",
        failureTitle: "تعذر إضافة التوقيت",
        failureMessage:
          "حدث خطأ ما. يرجى التحقق من تفاصيل التوقيت والمحاولة مرة أخرى.",
      },
      deleteSlotModal: {
        shiftTitle: "حذف وردية",
        trainingTitle: "حذف جلسة تدريب",
        confirmationMessage:
          "هل أنت متأكد أنك تريد حذف هذا التقرير؟\nلا يمكن التراجع عن هذا الإجراء.",
        date: "التاريخ",
        checkIn: "تسجيل الدخول",
        checkOut: "تسجيل الخروج",
        workingHours: "ساعات العمل",
        checkoutType: "نوع تسجيل الخروج",
        warning:
          "سيؤدي حذف هذا التوقيت إلى تحديث ساعات عمل المتقدم والراتب المتوقع.",
        deleteSlot: "حذف التوقيت",
      },
    },
    sending: "إرسال",
    sendNotification: "إرسال إشعار",
    messageRequired: "الرسالة مطلوبة",
    pushNotification: "إشعار دفع",
    sendPushNotification: "إرسال إشعار دفع",
    notificationSend: "تم إرسال الإشعار",
    submitEventPushNotification: "هل أنت متأكد أنك تريد إرسال الإشعار؟",
    cancelModalConfirmMessage: "هل أنت متأكد أنك تريد إلغاء هذه الفعالية؟",
    deleteModalConfirmMessage:
      "الفعالية المحذوفة لا يمكن إسترجاعها , هل أنت متأكد أنك تريد حذف هذه الفعالية ؟",
    completedEvaluationBtn: "ابدأ جولة التقييم",
    startEvaluationRound: "هل انت متاكد انك تريد بدء جولة تقييم ل ",
    disbaledCreateEvaluationBtnHint: "الزر معطل لان أيام التفكيك قد بدأت",
    checkedinApplicants: "سجلوا الدخول",
    noncheckedinApplicants: "لم يسجلوا الدخول",
    checkinStatus: "حالة تسجيل الدخول",
    checkedIn: "سجل الدخول",
    nonCheckedIn: "لم يسجل الدخول",
    paidTraining: {
      sectionTitle: "عرض تفاصيل التدريب المدفوع",
      trainingName: "اسم التدريب",
      trainingDescription: "وصف التدريب",
      trainingStart: "تاريخ ووقت بداية التدريب",
      trainingEnd: "تاريخ ووقت نهاية التدريب",
      checkInMargin: "الهامش الزمني لدخول التدريب",
      checkInBeforeMargin: "قبل بداية التدريب (بالدقائق)",
      checkInAfterMargin: "بعد بداية التدريب (بالدقائق)",
      checkOutMargin: "الهامش الزمني لخروج التدريب",
      checkOutBeforeMargin: "قبل انتهاء التدريب (بالدقائق)",
      checkOutAfterMargin: "بعد انتهاء التدريب (بالدقائق)",
      numberOfDays: "عدد أيام التدريب",
      payrollAmount: "مبلغ رواتب التدريب",
      payrollPerDay: "راتب التدريب اليومي",
      location: "موقع التدريب",
      locationBoundaries: "حدود الموقع",
      trainingAttendanceQrCode: "رمز QR لحضور التدريب",
      print: "طباعة",
    },
    evaluationsTab: {
      subTabs: {
        applicants: "تقييمات المتقدمين",
        company: "تقييمات الشركة",
      },
      searchPlaceholder: "البحث برقم الجولة",
      filterStatus: "الحالة",
      filterStartDate: "تاريخ البدء",
      filterEndDate: "تاريخ الانتهاء",
      runningIndicator: "{name} قيد التشغيل",
      startEvaluationRound: "ابدأ جولة التقييم",
      companyTab: {
        emptyTitle: "لا توجد جولات تقييم بعد",
        emptyDescription: "ابدأ جولتك الأولى لتبدأ في تقييم المتقدمين",
        pendingTitle: "لم يتم تقديم أي تقييم بعد",
        pendingDescription: "لم يقدم العميل استبيان الرضا الخاص بهذا الحدث بعد.",
        overallSatisfaction: "الرضا العام",
        evaluationStatus: "حالة التقييم",
        statusCompleted: "مكتمل",
        statusPending: "معلق",
        suggestionsFeedback: "الاقتراحات / التغذية الراجعة",
        noFeedback: "لم يتم تقديم أي ملاحظات.",
        criteriaGroups: {
          serviceAndQuality: "الخدمة والجودة",
          reliabilityAndSupport: "الموثوقية والدعم",
          financialAndAdmin: "المالية والإدارة",
        },
        criteria: {
          serviceQuality: "جودة الخدمة",
          attentionToDetail: "الاهتمام بالتفاصيل",
          understandingRequests: "فهم المتطلبات",
          speedOfResponse: "سرعة الاستجابة",
          complaintResolutionSpeed: "سرعة حل الشكاوى",
          wayOfResolvingComplaints: "طريقة حل الشكاوى",
          compliance: "الامتثال",
          adminFinanceCooperation: "التعاون الإداري والمالي",
          priceTermsOfPayments: "الأسعار وشروط الدفع",
        },
      },
      satisfactionSurveyForm: {
        title: "استبيان الرضا",
        subtitle: "شاركنا رأيك في أداء الشركة لهذه الفعالية.",
        clickToRate: "انقر على النجوم للتقييم",
        feedbackPlaceholder: "أدخل اقتراحاتك أو ملاحظاتك هنا ...",
        evaluationStatus: "حالة التقييم",
        statusInProgress: "قيد التنفيذ",
        cancel: "إلغاء",
        submit: "إرسال التقييم",
        submitSuccess: "تم إرسال استبيان الرضا الخاص بك.",
      },
      rangeTemplate: "عرض {from}-{to} من {total} جولة",
      rowsPerPageLabel: "عدد الصفوف",
      table: {
        round: "الجولة",
        applicantsNo: "عدد المتقدمين",
        startDate: "تاريخ البدء",
        endDate: "تاريخ الانتهاء",
        status: "الحالة",
        progress: "التقدم",
        emptyTitle: "لا توجد جولات تقييم",
        emptyDescription: "لم يتم إنشاء أي جولات تقييم لهذه الفعالية بعد.",
        noResultsTitle: "لا توجد جولات مطابقة",
        noResultsDescription: "لا توجد جولات تقييم تطابق بحثك أو عوامل التصفية المحددة.",
        statuses: {
          running: "جارية",
          completed: "مكتملة",
        },
      },
      runningButtonLabel: "جولة التقييم قيد التشغيل",
      runningTooltip: "ستظل جولة التقييم قيد التشغيل حتى يتم تقييم جميع المتقدمين.",
      startRoundModal: {
        title: "ابدأ جولة التقييم",
        message: "سيؤدي هذا إلى بدء جولة تقييم جديدة لجميع المتقدمين في هذه الفعالية. سيتمكن المقيّمون من تقديم الدرجات فور انطلاقها.",
        cancel: "إلغاء",
        confirm: "ابدأ الجولة",
      },
      applicantsView: {
        backToRounds: "العودة إلى الجولات",
        searchPlaceholder: "البحث بالاسم أو الدور",
        filterZone: "المنطقة",
        filterRole: "الدور",
        filterStatus: "الحالة",
        runningIndicator: "{name} قيد التشغيل",
        rangeTemplate: "عرض {from}-{to} من {total} متقدم",
        rowsPerPageLabel: "عدد الصفوف",
        table: {
          applicantName: "اسم المتقدم",
          role: "الدور",
          zoneName: "اسم المنطقة",
          evaluationDate: "تاريخ التقييم",
          status: "الحالة",
          actions: "الإجراءات",
          viewResult: "عرض النتيجة",
          evaluate: "تقييم",
          emptyTitle: "لا يوجد متقدمون",
          emptyDescription: "لم يتم العثور على متقدمين لهذه الجولة التقييمية.",
          noResultsTitle: "لا يوجد متقدمون مطابقون",
          noResultsDescription: "لا يوجد متقدمون يطابقون بحثك أو عوامل التصفية المحددة.",
          statuses: {
            pending: "قيد الانتظار",
            done: "مكتمل",
          },
        },
        viewResultForm: {
          overallSatisfaction: "نسبة الرضا الكلية",
          statusCompleted: "مكتمل",
          statusInProgress: "قيد التنفيذ",
          allRoundsSummary: "ملخص جميع الجولات",
          average: "المتوسط",
          noFeedback: "لم يتم تقديم ملاحظات.",
          editEvaluation: "تعديل التقييم",
          clickToReRate: "اضغط على النجوم لإعادة التقييم",
          saveChanges: "حفظ التغييرات",
          cancel: "إلغاء",
          saveSuccess: "تم حفظ تغييرات التقييم بنجاح.",
        },
        evaluateForm: {
          title: "تقييمات المتقدمين",
          subtitle: "مراجعة الأداء لجولة تقييم {roundName}.",
          applicantDetails: "تفاصيل المتقدم",
          staffName: "اسم الموظف",
          role: "الدور",
          assignedZone: "المنطقة المعيّنة",
          performanceIndicators: "مؤشرات الأداء",
          clickToRate: "انقر على النجوم للتقييم",
          criteria: {
            wellPresentable: "المظهر اللائق",
            interactionWithPeople: "التفاعل مع الآخرين",
            punctuality: "الانضباط في المواعيد",
            behavioralAttitude: "السلوك والتصرف",
            performance: "الأداء",
            followWorkRegulation: "الالتزام بأنظمة العمل",
          },
          detailedFeedback: "ملاحظات تفصيلية",
          feedbackPlaceholder: "أدخل ملاحظاتك حول الأداء هنا ...",
          evaluationStatus: "حالة التقييم",
          statusInProgress: "قيد التنفيذ",
          cancel: "إلغاء",
          submit: "إرسال التقييم",
        },
      },
    },
  },
  editEvents: {
    editEventBreadcrumb: "تعديل الفعالية",
    readOnlyEventCannotEditStatus:
      "لا يمكن تعديل هذه الفعالية لأن حالتها {status}.",
    conflictModalTitle: "تداخل في التواريخ — سيتم إلغاء المتقدمين",
    conflictModalMessage:
      "التواريخ الجديدة تتداخل مع فعالية جارية تشترك معها في متقدمين معتمدين. سيتم إلغاء هؤلاء المتقدمين تلقائيًا إذا تابعت. هل تريد المتابعة؟",
  },
  exportApplicants: {
    subtitle: "حدد الحقول التي تريد تضمينها في الملف.",
    confirmExport: "تأكيد التصدير",
    autoDeductionAmount: "مبلغ الخصم التلقائي",
    manualDeductionAmount: "مبلغ الخصم اليدوي",
    manualDeductionReason: "سبب الخصم اليدوي",
    rewardAmount: "مبلغ المكافأة",
    rewardReason: "سبب المكافأة",
    trainingDays: "أيام التدريب",
    numberOfTrainingDays: "عدد أيام التدريب",
    trainingDailyAmount: "راتب التدريب اليومي",
    trainingTotalAmount: "إجمالي راتب التدريب",
    checkInStatus: "حالة الحضور",
    checkInTime: "وقت الحضور",
    checkOutTime: "وقت الانصراف",
    dailyAmount: "المبلغ اليومي",
    date: "التاريخ",
    email: "البريد الإلكتروني",
    gender: "الجنس",
    id: "الرقم التعريفي",
    imageUrl: "رابط الصورة",
    name: "الاسم",
    note: "ملاحظة",
    numberOfWorkingDays: "عدد أيام العمل",
    phoneNumber: "رقم الهاتف",
    role: "الدور",
    status: "الحالة",
    allocationStatus: "حالة التعيين",
    stcNumber: "رقم STC",
    nationalId: "رقم الهوية",
    supervisor: "المشرف",
    totalAmount: "المبلغ الإجمالي (تدريب + فترة)",
    totalShiftAmount: "إجمالي مبلغ الفترة",
    zone: "المنطقة",
    image: "الصورة",
  },
};

export default events;
